import { lazy, Suspense } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";
import styles from "./styles.module.scss";
import DecorImage from "../assets/summer-girl-desktop.webp";
import { TENGE_LABEL } from "@/common/constants/common";
import {
  GESV_RATE_MAX,
  GESV_RATE_MIN,
  GRACE_PERIOD_DAYS,
  LOAN_AMOUNT_MAX_VALUE,
} from "@/common/constants/loan";
import { formatAmount } from "@/common/utils/formatNumber";
import { Typography } from "@/shared/ui/Typography";
import { LIGHT_COLOR } from "@/styles/colorsJS";

const CalculatorWidget = lazy(
  () =>
    import(
      /* webpackChunkName: "calculator-widget-desktop", webpackPrefetch: true */ "@/widgets/CalculatorWidget"
    ),
);

const BannerDesktop = () => {
  return (
    <div className={styles.bannerSection}>
      <div className={styles.backgroundDecor} />
      <div className={cn("container", styles.container)}>
        <div className={styles.leftSide}>
          <h1 className={styles.title}>
            <FormattedMessage
              defaultMessage="Микрокредит онлайн на карту до {amount}"
              values={{
                amount: (
                  <span className={styles.actual}>
                    {formatAmount(LOAN_AMOUNT_MAX_VALUE)} {TENGE_LABEL}
                  </span>
                ),
              }}
            />
          </h1>
          <Suspense fallback={null}>
            <CalculatorWidget className={styles.calculator} />
          </Suspense>
        </div>
        <div className={styles.rightSide}>
          <img
            className={styles.decorImage}
            src={DecorImage}
            alt="decor image"
          />
          <div className={styles.bullet}>
            <Typography type="h3" color={LIGHT_COLOR} align="center">
              <FormattedMessage
                defaultMessage="Первые {period} дней под 0%"
                values={{ period: GRACE_PERIOD_DAYS }}
              />
            </Typography>
            <Typography type="h3" color={LIGHT_COLOR} align="center">
              <FormattedMessage
                defaultMessage="с 8-го дня ГЭСВ от {rateMin} до {rateMax}"
                values={{
                  rateMin: GESV_RATE_MIN,
                  rateMax: GESV_RATE_MAX,
                }}
              />
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerDesktop;
